import { NavigationGuardNext, Route } from 'vue-router';
import { loggedIn, user } from '@/ui/auth/auth';
import { EventTypes, setUserId, trackEvent } from '@/services/activityTracker/activityTrackerHelper';

function getTab(to: Route) {
  if (!to.query!.tab) {
    return {};
  }

  return {
    tab: to.query.tab,
  };
}

export function trackRoutes(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): void {
  if (loggedIn.value) {
    setUserId(user.value.email);

    trackEvent(EventTypes.urlVisit, { page: to.name || '', from: from.name, ...getTab(to) });
  }

  next();
}
